import React, { useEffect, useState } from "react";
import ModalComp from "../themes/Model";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  createTheme,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { useModalContext } from "../ModalContext";
import dayjs from "dayjs";
import { getUser } from "../helpers";
import api from "../axiosConfig";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

function CreateActual({
  open,
  setActualModalOpen,
  warehouses,
  setWarehouses,
  selectedWarehouse,
  setSelectedWarehouse,
  isWarehouseDisabled,
  channels,
  setChannels,
  selectedChannel,
  setSelectedChannel,
  isChannelDisabled,
  categories,
  setCategories,
  selectedCategory,
  setSelectedCategory,
  isPriceListDisabled,
  priceLists,
  setPriceLists,
  selectedPriceList,
  setSelectedPriceList,
  productNames,
  selectedProduct,
  setSelectedProduct,
  setSelectedProductCode,
  isProductDisabled,
  openNotification,
  setNotification,
  setNotificationText,
  isSchemeTypeDisabled,
  selectedPriceListValue,
  setSelectedPriceListValue,
  setSnackbarMessage,
  setSnackbarOpen,
  modalHeader,
  modalType,
  modalFormData,
  setModalFormData,
  resetForm,
  errors,
  setErrors,
  rowPriceList,
}) {
  const { currency, isLoading, setLoading } = useModalContext();
  // const [selectedChannel, setSelectedChannel] = useState([]);
  const user = getUser();

  //effect
  useEffect(() => {
    if (selectedChannel && selectedChannel.length > 0) {
      api
        .post("/pricelist", {
          channel: selectedChannel,
          page: "scheme",
          user: user,
        })
        .then((response) => {
          setPriceLists(response.data || []);
        })
        .catch((error) => console.error("Error fetching pricelists:", error));
    } else {
      setPriceLists([]); // Clear priceList dropdown if no channel is selected
    }
    if (modalHeader === "Add new actual") {
      setPriceLists([]);
    }
    return () => setPriceLists([]);
  }, [selectedChannel]);

  //handel

  //warehouse 02
  const handleWarehouseChange02 = (event, newWarehouseValue) => {
    const selectedWarehouse = warehouses.find(
      (warehouse) => warehouse.Warehouse === newWarehouseValue
    );

    setSelectedWarehouse(selectedWarehouse ? selectedWarehouse.Warehouse : "");
    setModalFormData((prevData) => ({
      ...prevData,
      warehouse: selectedWarehouse ? selectedWarehouse.Warehouse : "",
    }));

    if (newWarehouseValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse: "",
      }));
    }
  };

  //channel 02
  const handleChannelChange02 = (event, newValue) => {
    const selectedChannelObj = channels.find(
      (channel) => channel.Channel === newValue
    );

    const selectedChannelValue = selectedChannelObj
      ? selectedChannelObj.Channel
      : "";
    setSelectedChannel(selectedChannelValue);

    // Reset PriceList when channel changes
    setSelectedPriceList(null);
    setSelectedPriceListValue("");

    setModalFormData((prevData) => ({
      ...prevData,
      channel: selectedChannelValue,
      priceList: "",
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        channel: "",
      }));
    }
  };

  //price-list 02

  const handlePriceListChange = (event, newValue) => {
    setSelectedPriceList(newValue);
    setSelectedPriceListValue(newValue ? newValue?.Pricelist : "");

    setModalFormData((prevData) => ({
      ...prevData,
      priceList: newValue ? newValue.PriceList : "",
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        priceList: "",
      }));
    }
  };

  //product 02
  const handleProductChange02 = (event, newValue) => {
    const selectedProduct = productNames.find(
      (product) => product.Product_Name === newValue
    );

    setSelectedProduct(selectedProduct ? selectedProduct.Product_Name : "");
    setModalFormData((prevData) => ({
      ...prevData,
      product: selectedProduct ? selectedProduct.Product_Name : "",
      productCode: selectedProduct ? selectedProduct.ProductCode : null,
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        product: "",
      }));
    }
  };

  // handel change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setModalFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear the field-specific error if valid input is entered
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error for the specific field being updated
    }));

    if (openNotification) {
      setNotification(false);
      setNotificationText("");
    }
  };

  //reset-form
  const handelCloseModal = () => {
    resetForm();
    setActualModalOpen(false);
    setSelectedWarehouse([]);
    setSelectedChannel([]);
    setSelectedCategory([]);
    setSelectedProduct([]);
    setSelectedPriceList([]);
  };

  // dropdown data
  const mrpRate = [
    { MrpValue: "MRP", name: "MRP" },
    { MrpValue: "PTR", name: "PTR" },
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!modalFormData.schemeName || modalFormData.schemeName.trim() === "")
      newErrors.schemeName = "Scheme Name is required";

    if (!modalFormData.schemeType || modalFormData.schemeType.trim() === "")
      newErrors.schemeType = "Scheme Type is required";

    if (!modalFormData.warehouse || modalFormData.warehouse.length === 0)
      newErrors.warehouse = "Warehouse is required";

    if (!modalFormData.product || modalFormData.product.length === 0)
      newErrors.product = "Product is required";

    if (!modalFormData.channel || modalFormData.channel.length === 0)
      newErrors.channel = "Channel is required";

    // if (!selectedPriceListValue || selectedPriceListValue.trim() === "") {
    //     newErrors.priceList = "Please select at least one Price List";
    //   }

    if (
      (!selectedPriceListValue || selectedPriceListValue.trim() === "") &&
      (!rowPriceList || rowPriceList.trim() === "")
    ) {
      newErrors.priceList = "Please select Pricelist";
    }

    if (!modalFormData.schemeStartDate)
      newErrors.schemeStartDate = "Start date is required";

    if (!modalFormData.schemeEndDate)
      newErrors.schemeEndDate = "End date is required";

    if (modalFormData.schemeStartDate && modalFormData.schemeEndDate) {
      const start = dayjs(modalFormData.schemeStartDate);
      const end = dayjs(modalFormData.schemeEndDate);
      if (end.isBefore(start))
        newErrors.schemeEndDate = "End date cannot be before start date";
    }

    // Conditional Validations Based on Scheme Type
    if (modalFormData.schemeType === "Off Invoice") {
      if (!modalFormData.costSpent)
        newErrors.costSpent = "cost spent is required";
      else if (isNaN(modalFormData.costSpent))
        newErrors.costSpent = "cost spent must be a number";
    }

    if (modalFormData.schemeType === "Visibility") {
      if (!modalFormData.costSpent)
        newErrors.costSpent = "cost spent is required";
      else if (isNaN(modalFormData.costSpent))
        newErrors.costSpent = "cost spent must be a number";

      if (!modalFormData.schemeImpactValue)
        newErrors.schemeImpactValue = "Scheme Impact Value is required";
      else if (isNaN(modalFormData.schemeImpactValue))
        newErrors.schemeImpactValue = "Scheme Impact Value must be a number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //update apiEndpoint
  const handleCreateSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // API endpoint and payload
    const apiEndpoint = "/api/schemeaddactual";

    const payload = {
      body: {
        schemeName: modalFormData.schemeName,
        warehouse: modalFormData.warehouse,
        schemeStartDate: modalFormData.schemeStartDate,
        schemeEndDate: modalFormData.schemeEndDate,
        channel: modalFormData.channel,
        pricelist: selectedPriceListValue,
        schemeType: modalFormData.schemeType,
        user,
        page: "scheme",
        currencyType: "Native",
        rateImpact: modalFormData.rateImpact,
        quantityImpact: modalFormData.quantityImpact,
        schemeImpactValue: modalFormData.schemeImpactValue,
        product: modalFormData.product,
        Cost_Spend: modalFormData.costSpent,
        product: modalFormData.productCode,
      },
    };
    setLoading(true);
    api
      .post(apiEndpoint, payload)
      .then((response) => {
        // Check if the response indicates failure
        if (response.data.Status === false) {
          setNotificationText(
            response.data.SchemeStatus || "An error occurred, please try again."
          );
          setNotification(true);
          setActualModalOpen(true);
          setLoading(false);
        } else {
          // Success case
          setSnackbarMessage("Your new scheme request has been submitted.");
          setSnackbarOpen(true); // Show the snackbar
          handelCloseModal();
          setNotification(false);
          setNotificationText(""); // Reset notification
          setSelectedPriceList("");
          setActualModalOpen(false);
          //   handleCloseModal();
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error during API call:", error);
        setNotificationText(
          "An error occurred while submitting the data. Please try again."
        );
        setNotification(true);
        setActualModalOpen(true);
        setLoading(false);
      });
  };

  // date picker style
  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  //create scheme modal content
  const modalContent = (
    <>
      <Box>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Scheme Name"
                name="schemeName"
                value={modalFormData.schemeName}
                onChange={(e) => {
                  const value = e.target.value;
                  setModalFormData((prevData) => ({
                    ...prevData,
                    schemeName: value,
                  }));
                  if (value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      schemeName: "",
                    }));
                  }
                }}
                error={Boolean(errors.schemeName)}
                size="small"
              />
              {errors.schemeName && (
                <FormHelperText
                  sx={{
                    color: "#FF0000",
                    marginTop: "4px",
                  }}
                >
                  {errors.schemeName}*
                </FormHelperText>
              )}
            </Grid>

            <ThemeProvider theme={customTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  className="scheme-date-picker"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    marginTop: "20px",
                    marginLeft: "16px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Scheme Start Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeStartDate
                          ? dayjs(modalFormData.schemeStartDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeStartDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeStartDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          margin="normal"
                          error={Boolean(errors.schemeStartDate)}
                        />
                      )}
                      disablePast={
                        modalHeader !== "Add new actual" &&
                        modalHeader !== "Edit Actual"
                      }
                      shouldDisableDate={(date) => {
                        if (modalType !== "scheme") return false;

                        const today = dayjs().startOf("day");
                        const tomorrow = today.add(1, "day");
                        const endDate = modalFormData.schemeEndDate
                          ? dayjs(modalFormData.schemeEndDate)
                          : null;

                        return (
                          date.isSame(today, "day") ||
                          date.isSame(tomorrow, "day") ||
                          (endDate && date.isAfter(endDate, "day"))
                        );
                      }}
                    />{" "}
                    {errors.schemeStartDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeStartDate}*
                      </FormHelperText>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Scheme End Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeEndDate
                          ? dayjs(modalFormData.schemeEndDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeEndDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeEndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth margin="normal" />
                      )}
                      disablePast={
                        modalHeader !== "Add new actual" &&
                        modalHeader !== "Edit Actual"
                      }
                      shouldDisableDate={(date) => {
                        if (modalType !== "scheme") {
                          const startDate = modalFormData.schemeStartDate
                            ? dayjs(modalFormData.schemeStartDate)
                            : "";
                          return date.isBefore(startDate, "day");
                        } else {
                          const today = dayjs().startOf("day");
                          const tomorrow = today.add(1, "day");
                          const startDate = modalFormData.schemeStartDate
                            ? dayjs(modalFormData.schemeStartDate)
                            : dayjs().startOf("day");
                          return (
                            date.isSame(today, "day") ||
                            date.isSame(tomorrow, "day") ||
                            date.isBefore(startDate, "day")
                          );
                        }
                      }}
                    />
                    {errors.schemeEndDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeEndDate}*
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </LocalizationProvider>
            </ThemeProvider>

            <>
              {/* warehouse & channel */}
              <Grid
                item
                sx={{
                  display: "flex",
                  gap: "20px",
                  marginTop: "5px",
                  width: "100%",
                }}
              >
                <FormControl
                  xs={6}
                  style={{ width: "100%", flexGrow: 1 }}
                  error={!!errors.warehouse}
                >
                  <Autocomplete
                    options={warehouses.map(({ Warehouse }) => Warehouse)}
                    disabled={isWarehouseDisabled}
                    value={selectedWarehouse || null}
                    onChange={handleWarehouseChange02}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Warehouse"
                        variant="outlined"
                        fullWidth
                        error={!!errors.warehouse}
                      />
                    )}
                    sx={{ width: "100%" }}
                    error={Boolean(errors.warehouse)}
                    size="small"
                  />
                  {errors.warehouse && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.warehouse}*
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  xs={6}
                  style={{ width: "100%", flexGrow: 1 }}
                  error={!!errors.channel}
                >
                  <Autocomplete
                    disabled={isChannelDisabled}
                    options={channels.map(({ Channel }) => Channel)}
                    value={selectedChannel || null}
                    onChange={handleChannelChange02}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Channel"
                        variant="outlined"
                        fullWidth
                        error={!!errors.channel}
                      />
                    )}
                    sx={{ width: "100%" }}
                    error={Boolean(errors.channel)}
                    size="small"
                  />
                  {errors.channel && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.channel}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              {/* product and price-list */}
              <Grid item sx={{ display: "flex", gap: "20px", width: "100%" }}>
                <FormControl
                  style={{ width: "100%", flexGrow: 1 }}
                  error={!!errors.product}
                >
                  <Autocomplete
                    disabled={isProductDisabled}
                    options={productNames.map(
                      ({ Product_Name }) => Product_Name
                    )}
                    value={selectedProduct || null}
                    onChange={handleProductChange02}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product"
                        variant="outlined"
                        fullWidth
                        error={!!errors.product}
                      />
                    )}
                    sx={{ width: "100%" }}
                    size="small"
                  />
                  {errors.product && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.product}*
                    </FormHelperText>
                  )}
                </FormControl>

                <FormControl
                  style={{ width: "100%", flexGrow: 1 }}
                  error={!!errors.priceList}
                >
                  <Autocomplete
                    disabled={isPriceListDisabled}
                    options={priceLists}
                    getOptionLabel={(option) => option.Pricelist || ""}
                    value={
                      modalHeader !== "Add new actual" ? selectedPriceList : ""
                    }
                    onChange={handlePriceListChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="PriceList"
                        variant="outlined"
                        fullWidth
                        error={!!errors.priceList}
                      />
                    )}
                    sx={{ width: "100%" }}
                    size="small"
                  />
                  {errors.priceList && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000 !important",
                        marginTop: "4px !important",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                    >
                      {errors.priceList}*
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </>

            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="Scheme Type"
                name="schemeType"
                value={modalFormData.schemeType}
                onChange={handleChange}
                error={!!errors.schemeType}
                helperText={errors.schemeType || ""}
                disabled={isSchemeTypeDisabled}
                size="small"
              >
                {["On Invoice", "Off Invoice", "Visibility"].map(
                  (type, index) => (
                    <MenuItem
                      key={index}
                      value={type}
                      disabled={type === "On Invoice"}
                    >
                      {type}
                    </MenuItem>
                  )
                )}
              </TextField>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {["On Invoice"].includes(modalFormData.schemeType) && (
                <TextField
                  fullWidth
                  select
                  label="Discount Pricing Impact"
                  name="mrpRate"
                  value={modalFormData.mrpRate || ""}
                  onChange={handleChange}
                  error={!!errors.mrpRate}
                  helperText={errors.mrpRate || ""}
                  size="small"
                >
                  {mrpRate.map((rate, index) => (
                    <MenuItem key={index} value={rate.MrpValue}>
                      {rate.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}

              {/* Conditionally render Rate Impact and Quantity Impact based on Scheme Type */}
              <Box
                sx={{
                  display: "flex",
                  gap: "20px",
                }}
              >
                {["On Invoice", "Off Invoice", "Visibility"].includes(
                  modalFormData.schemeType
                ) && (
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Cost Spent"
                      name="costSpent"
                      value={modalFormData.costSpent || ""}
                      onChange={handleChange}
                      size="small"
                      error={Boolean(errors.costSpent)}
                    />

                    {errors.costSpent && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.costSpent}*
                      </FormHelperText>
                    )}
                  </Grid>
                )}
              </Box>

              {["Visibility"].includes(modalFormData.schemeType) && (
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Scheme Impact Value"
                    name="schemeImpactValue"
                    value={modalFormData.schemeImpactValue}
                    onChange={handleChange}
                    size="small"
                    error={Boolean(errors.schemeImpactValue)}
                  />

                  {errors.schemeImpactValue && (
                    <FormHelperText
                      sx={{
                        color: "#FF0000",
                        marginTop: "4px",
                      }}
                    >
                      {errors.schemeImpactValue}*
                    </FormHelperText>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );

  //   modelButtons
  const actionButtons = (
    <>
      <Box sx={{ textAlign: "right" }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isLoading}
          loadingPosition="end"
          onClick={handleCreateSubmit}
          style={{
            backgroundColor: "#16a695",
            color: "white",
            backgroundColor:
              modalFormData.schemeType === "On Invoice"
                ? "#e0e0e0"
                : isLoading
                ? "#16a69590"
                : "#16a695",
            color:
              modalFormData.schemeType === "On Invoice" ? "#9e9e9e" : "#fff",
            cursor:
              modalFormData.schemeType === "On Invoice"
                ? "not-allowed"
                : "pointer",
            paddingRight: isLoading ? "35px" : "",
          }}
          size="small"
          disabled={modalFormData.schemeType === "On Invoice"}
        >
          {"Request New Actual"}
        </LoadingButton>
        &nbsp;&nbsp;&nbsp;
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handelCloseModal();
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #707070",
            borderColor: "#707070",
            color: "#000",
          }}
          size="small"
        >
          Close
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <ModalComp
        open={open}
        setActualModalOpen={setActualModalOpen}
        handelCloseModal={handelCloseModal}
        title={modalHeader}
        modalContent={modalContent}
        modelButtons={actionButtons}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "682px",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
          actionButtonContainerStyle: {
            padding: "0 20px 20px 20px",
          },
        }}
      />
    </>
  );
}

export default CreateActual;
